import {saveFile, saveFileSupported} from '../atUtils'
import messageResource from '../messageResource'
import json2csv from '../json2csv/json2csv'

export function downloadJsonAsCSV(jsons, fileName, callback = () => {}) {
    if (!saveFileSupported())
        alert(messageResource.getMessage('js.alert.operation_unsupported'))

    const eol = '\r\n'
    const separator = window.SystemSettings.csvSeparator

    const encoding = window.SystemSettings.csvMultilanguage ? 'UTF-16' : 'UTF-8'

    json2csv(jsons, separator, eol, false, function(csv) {
        saveFile(csv, fileName, {encoding: encoding, 'type': `text/csv;charset=${encoding}`})
        callback()
    })
}



// WEBPACK FOOTER //
// ./web/js/csv/utils.js